function initialState() {
    return {
        entityManagerActive: true,
        lastType: "",
    }
}

export default {
    state: initialState(),
    getters: {
        ENTITY_MANAGER_ACTIVE: state => state.entityManagerActive,
        LAST_ENTITY_MANAGER_TYPE: state => state.lastType,
    },
    mutations: {
        SET_ENTITY_MANAGER_ACTIVE(state, payload) {
            state.entityManagerActive = payload;
        },
        SET_LAST_ENTITY_MANAGER_TYPE(state, payload) {
            state.lastType = payload;
        },
    }
}
